import { SvgIcon, SvgIconProps } from '@mui/material'
import React from 'react'

const Tire: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox='0 0 24 24'>
      <path
        fill={props?.fill ?? '#1E1E1E'}
        d='M9.947 14.225v4.177L6.95 19.907v-4.17l2.997-1.512ZM9.947 9.321v4.177L6.95 15.003v-4.177L9.947 9.32ZM9.947 4.417v4.178L6.95 10.103V5.916h.023l2.974-1.499ZM9.947.649v3.045L6.95 5.228V2.27A1.622 1.622 0 0 1 8.572.65h1.375ZM9.947 19.135v4.216H8.572A1.622 1.622 0 0 1 6.95 21.73v-1.093l2.997-1.502ZM10.745.649h2.513V23.35h-2.513V.65ZM17.05 2.27v2.92l-2.997-1.506V.65h1.375A1.622 1.622 0 0 1 17.05 2.27ZM14.053 4.417 17.05 5.92v4.174l-2.997-1.498V4.417ZM14.053 9.321l2.997 1.505v4.18l-2.997-1.508V9.321ZM14.053 14.225l2.997 1.498v4.19l-2.997-1.51v-4.178ZM17.05 20.627v1.103a1.622 1.622 0 0 1-1.622 1.621h-1.375v-4.216l2.935 1.47.062.022Z'
      />
    </SvgIcon>
  )
}

export default Tire
